export enum ReturnSearchType {
  Codes = 'codes',
  Cpf = 'cpf',
  CustomerName = 'customerName',
}

export type ReturnSearchForm = {
  searchType: ReturnSearchType;
  filterDate: string;
  codes: string;
  cpf: string;
  customerName: string;
};

export type ReturnFilterForm = {
  startDate: number;
  endDate: number;
  returnStatuses: string[];
  filterDate: string;
};
